import { resetChangeEmail } from "application/changeEmail/changeEmailActions";
import { resetDeleteAccount } from "application/deleteAccount/deleteAccountActions";
import { ErrorBoundary } from "components/common/ErrorBoundary/ErrorBoundary";
import { NavButton } from "components/common/NavButton/NavButton";
import React, { useEffect } from "react";
import { FormattedMessage } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import styles from "./SettingsError.module.css";

let SettingsError = ({ title, message, ...props }) => {
  const menu = useSelector(state => state.menu);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(resetDeleteAccount());
    dispatch(resetChangeEmail());
  }, []);

  return (
    <ErrorBoundary>
      <div className={`arc3-container ${styles.container}`} {...props}>
        <div className="arc3-padding--left-lg arc3-padding--right-lg">
          <h1>{title}</h1>
          <p>{message}</p>
          <NavButton href="/settings" data-cy="SettingsErrorTryAgainButton">
            <FormattedMessage id="settingsError.tryAgainButton" defaultMessage="Try again" />
          </NavButton>

          <p className="arc3-padding--top-lg">
            <FormattedMessage
              id="settingsError.customerCareText"
              defaultMessage="You tried again and are still having issues? Please"
            />{" "}
            <a href={menu.items.routes.ContactUs} data-cy="SettingsErrorPageCustomerCareLink">
              <FormattedMessage id="settingsError.customerCareLinkText" defaultMessage="contact customer care" />
            </a>
          </p>
        </div>
      </div>
    </ErrorBoundary>
  );
};

export const DeleteAccountError = () => {
  return (
    <SettingsError
      title={<FormattedMessage id="deleteAccountError.title" defaultMessage="Your account couldn’t be deleted" />}
      message={
        <FormattedMessage
          id="deleteAccountError.message"
          defaultMessage="Something went wrong with the account deletion. Could you please try again?"
        />
      }
      data-cy="DeleteAccountErrorPage"
    />
  );
};

export const ChangeEmailError = () => {
  return (
    <SettingsError
      title={<FormattedMessage id="changeEmailError.title" defaultMessage="Your email wasn't changed" />}
      message={
        <FormattedMessage
          id="changeEmailError.message"
          defaultMessage="Something went wrong with the email change. Could you please try again?"
        />
      }
      data-cy="ChangeEmailErrorPage"
    />
  );
};
